import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=c1b82fdc&scoped=true"
import script from "./Settings.vue?vue&type=script&lang=js"
export * from "./Settings.vue?vue&type=script&lang=js"
import style0 from "./Settings.vue?vue&type=style&index=0&id=c1b82fdc&prod&lang=scss&scoped=true"
import style1 from "./Settings.vue?vue&type=style&index=1&id=c1b82fdc&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1b82fdc",
  null
  
)

export default component.exports